import { Tooltip as AntTooltip } from 'antd'
import { TooltipProps } from 'antd/lib/tooltip'

export const Tooltip = ({ maxLength = 1000, ...props }: TooltipProps & { maxLength?: number }) => {
  const truncatedTitle =
    typeof props.title === 'string' && props.title.length > maxLength
      ? props.title.slice(0, maxLength) + '...'
      : props.title

  return <AntTooltip {...props} title={truncatedTitle} />
}
